/* eslint-disable func-names */
// global pollyfill needed for scrollbar library
window.global = window;

Reflect.defineProperty(Array.prototype, "isEmpty", {
  value: function () {
    return this.length === 0;
  },
  writable: false
});

if (!Array.prototype.toSorted) {
  Reflect.defineProperty(Array.prototype, "toSorted", {
    value: function (compareFn) {
      return this.slice().sort(compareFn);
    }
  });
}

window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, 1);
  };
window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

(function formatToPartsPolyfill() {
  if (!Intl.NumberFormat().formatToParts) {
    Reflect.defineProperty(Intl.NumberFormat.prototype, "formatToParts", {
      value: function (number) {
        if (
          number === null ||
          number === undefined ||
          isNaN(number) ||
          typeof (number * 1) !== "number"
        ) {
          return [
            {
              type: "nan",
              value: "NaN"
            }
          ];
        }
        let result = [];
        if (number < 0) {
          result.push({
            type: "minusSign",
            value: "-"
          });
          number = number * -1;
        }
        let separators = {};
        let _num = 10000000.23;
        let options = this.resolvedOptions();
        let locale = options.locale;
        Reflect.deleteProperty(options, locale);
        let _formattedNum = Intl.NumberFormat(locale, options).format(_num);
        _formattedNum = _formattedNum.split("");
        _formattedNum = _formattedNum.filter(
          (item) => [" ", ",", "."].indexOf(item) >= 0
        );
        separators.groupSeparator = _formattedNum[0];
        separators.decimalSeparator = _formattedNum[_formattedNum.length - 1];
        let formattedNum = Intl.NumberFormat(locale, options).format(number);
        let splitByDecimal = formattedNum.split(separators.decimalSeparator);
        let splitByGroup = splitByDecimal[0].split(separators.groupSeparator);
        splitByGroup.forEach((item, index) => {
          result.push({
            type: "integer",
            value: item
          });
          if (index !== splitByGroup.length - 1) {
            result.push({
              type: "group",
              value: separators.groupSeparator
            });
          }
        });
        if (splitByDecimal.length > 1 && splitByDecimal[1]) {
          result.push({
            type: "decimal",
            value: separators.decimalSeparator
          });
          result.push({
            type: "fraction",
            value: splitByDecimal[1]
          });
        }
        return result;
      },
      writable: false
    });
  }
})();
